import './pricingCategoryNoData.css'

function PricingCategoryNoData() {
   return (
      <div className='pricingCategoryNoData__container'>
         <p>Sorry, nothing is found here</p>
         <p>Please try All Products, Laptops and Computers categories</p>
      </div>
   )
}

export default PricingCategoryNoData